var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-email-template-form" },
    [
      _c("div", { staticClass: "create-email-template-form-models" }, [
        _c(
          "div",
          {
            staticClass: "create-email-template-form-models-item",
            class: { selected: _vm.formData.template === "empty" },
            on: {
              click: function ($event) {
                _vm.formData.template = "empty"
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "create-email-template-form-models-item-model" },
              [_c("EmptyIcon")],
              1
            ),
            _vm._v(
              "\n            " + _vm._s(_vm.$t("mail.empty")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "create-email-template-form-models-item",
            class: { selected: _vm.formData.template === "summer" },
            on: {
              click: function ($event) {
                _vm.formData.template = "summer"
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "create-email-template-form-models-item-model" },
              [_c("EmptyIcon")],
              1
            ),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("mail.summerDiscounts")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "create-email-template-form-models-item",
            class: { selected: _vm.formData.template === "opportunity" },
            on: {
              click: function ($event) {
                _vm.formData.template = "opportunity"
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "create-email-template-form-models-item-model" },
              [_c("EmptyIcon")],
              1
            ),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("mail.opportunities")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-form-model",
        {
          ref: "form",
          attrs: { model: _vm.formData, rules: _vm.rules, layout: "vertical" },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: _vm.$t("mail.templateName"), prop: "name" } },
            [
              _c("a-input", {
                model: {
                  value: _vm.formData.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: _vm.$t("message.subject"), prop: "subject" } },
            [
              _c("a-input", {
                model: {
                  value: _vm.formData.subject,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "subject", $$v)
                  },
                  expression: "formData.subject",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: _vm.$t("mail.category"), prop: "category" } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.formData.category,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "category", $$v)
                    },
                    expression: "formData.category",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "marketing" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.marketing"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "operational" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.operational"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "private" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.custom"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }